import React, { Fragment } from 'react';
import { connect } from 'react-redux';

import {
  Tooltip,
  Box,
  Button,
  IconButton,
  Dialog,
  DialogTitle,
  Grid,
  Typography,
  DialogContent,
  Tab,
  Tabs,
  AppBar
} from '@material-ui/core';
import { ScaleLoader } from 'react-spinners';
import AddCircleTwoToneIcon from '@material-ui/icons/AddCircleTwoTone';
import { RouteComponentProps } from 'react-router';
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';
import MUIDataTable, {
  SelectableRows,
  MUIDataTableMeta,
  MUIDataTableColumnOptions
} from 'mui-datatables';
import CloseIcon from '@material-ui/icons/Close';
import DeleteOutlineTwoToneIcon from '@material-ui/icons/DeleteOutlineTwoTone';
import moment from 'moment';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import { ProviderContext, withSnackbar } from 'notistack';
import { ApplicationState, AppState } from '../../store';
import { ITranslatorService } from '../../services/Interfaces/ITranslatorService';
import { IReferentialService } from '../../services/Interfaces/IReferentialService';
import { AppContext, ApplicationContext } from '../../context/Contexts';
import { SupplierProducer } from '../../interfaces/Workflow';
import { IWorkflowService } from '../../services/Interfaces/IWorkflowService';
import { MUITranslations } from '../../helpers/MUITableTranslations';

interface IUserSupplierProducersState {
  newSupplierProducer: SupplierProducer;
  supplierProducerList: SupplierProducer[];
  isLoading: boolean;
  isDialogOpen: boolean;
  newSupplierProducerId: number | null;
}
type IUserSupplierProducersProps = { appState: AppState } & ProviderContext &
  RouteComponentProps<{ id: string; workflowId: string }>;
class UserSupplierProducers extends React.PureComponent<
  IUserSupplierProducersProps,
  IUserSupplierProducersState
> {
  private translatorService!: ITranslatorService;
  private workflowService!: IWorkflowService;
  private appReferentialService!: IReferentialService;
  static contextType = ApplicationContext;
  private newSupplierProducer = {
    id: 0,
    producer: ''
  } as SupplierProducer;

  state = {
    supplierProducerList: [],
    isLoading: false,
    selectedFilter: 0,
    isDialogOpen: false,
    newSupplierProducer: this.newSupplierProducer,
    maintenancePackageList: [],
    newSupplierProducerId: null
  } as IUserSupplierProducersState;

  public componentDidMount() {
    this.setState(
      {
        isLoading: true
      },
      async () => {
        await this.loadSupplierProducerList();
      }
    );
  }

  loadSupplierProducerList = async () => {
    const supplierProducerList = await this.workflowService.GetSupplierProducers();

    this.setState({
      supplierProducerList: supplierProducerList,
      isLoading: false,
      newSupplierProducer: { ...this.newSupplierProducer }
    });
  };


  private handleProducerChange = (value: string) => {
    this.setState({
      newSupplierProducer: {
        ...this.state.newSupplierProducer,
        producer: value
      }
    });
  };
  

  public saveSupplierProducer = async () => {
    if (this.state.newSupplierProducerId === null) {
      try {
        await this.workflowService.AddSupplierProducer(this.state.newSupplierProducer);
        await this.loadSupplierProducerList();
        this.closeDialog();
        this.props.enqueueSnackbar(this.translatorService.Tranlate('SUCCES_MSG', 'OK'), {
          variant: 'success'
        });
      } catch (error) {
        this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
          variant: 'error'
        });
      }
    } else {
      try {
        await this.workflowService.UpdateSupplierProducer(this.state.newSupplierProducer);
        await this.loadSupplierProducerList();
        this.closeDialog();
        this.props.enqueueSnackbar(this.translatorService.Tranlate('SUCCES_MSG', 'OK'), {
          variant: 'success'
        });
      } catch (error) {
        this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
          variant: 'error'
        });
      }
    }
  };

  public renderAddForm() {
    return (
      <ValidatorForm onSubmit={this.saveSupplierProducer} instantValidate={true}>
        <Box mb={2}>
          <TextValidator
            fullWidth
            name="producer"
            id="producer"
            value={this.state.newSupplierProducer.producer || ''}
            onChange={(e: any) => this.handleProducerChange(e.target.value)}
            label={this.translatorService.Tranlate(
              'CALCULATION_DETAILS_PRODUCER_HEADER',
              'Producator'
            )}
            validators={['required']}
            errorMessages={[
              this.translatorService.Tranlate('VALIDATORS_REQUIRED', 'Campul este obligatoriu')
            ]}
          />
        </Box>

        <div className="text-right">
          <Button
            className="m-2"
            variant="outlined"
            color="default"
            onClick={this.closeDialog}
          >
            {this.translatorService.Tranlate('EDIT_ORGANIZATION_CANCEL_BTN', 'Anuleaza')}
          </Button>
          <Button className="m-2" variant="contained" color="secondary" type="submit">
            {this.translatorService.Tranlate('EDIT_ORGANIZATION_SAVE_BTN', 'Salveaza')}
          </Button>
        </div>
    </ValidatorForm>
    );
  }
  getColumns = () => {
    const columns = [
      {
        name: 'id',
        options: { display: 'excluded', filter: false } as MUIDataTableColumnOptions
      },
      {
        name: 'producer',
        label: this.translatorService.Tranlate(
          'CALCULATION_DETAILS_PRODUCER_HEADER',
          'Producator'
        ) 
      },
      {
        name: 'dateModification',
        label: this.translatorService.Tranlate('USERS_DATE_MODIFICATION_HEADER', 'Data Modificare'),
        options: {
          filter: false,
          sortDirection: 'desc',
          customBodyRender: (value: Date) =>
            moment.utc(value).local().format(this.props.appState.longDateFormat)
        } as MUIDataTableColumnOptions
      },
      {
        name: '',
        options: {
          viewColumns: false,
          filter: false,
          setCellHeaderProps: () => ({ align: 'center' }),
          setCellProps: () => ({ align: 'center' }),
          customBodyRender: (value: boolean, tableMeta: MUIDataTableMeta) => {
            return (
              <>
                <IconButton
                  aria-label="edit"
                  color="primary"
                  className="text-primary"
                  size="small"
                  onClick={(e) => this.newSupplierProducerPopup(tableMeta.rowData[0])}
                >
                    <EditOutlinedIcon />
                </IconButton>
                <IconButton
                  aria-label="delete"
                  color="inherit"
                  className="text-danger"
                  size="small"
                  onClick={(e) => this.deleteSupplierProducer(e, tableMeta)}
                >
                  <DeleteOutlineTwoToneIcon />
                </IconButton>
              </>
            );
          }
        }
      }];
    return columns;
  };

  deleteSupplierProducer = async (event: any, tableMeta: MUIDataTableMeta) => {
    try {
      const id = tableMeta.rowData[0];
      await this.workflowService.RemoveSupplierProducer(id);
      await this.loadSupplierProducerList();
      this.props.enqueueSnackbar(this.translatorService.Tranlate('SUCCES_MSG', 'OK'), {
        variant: 'success'
      });
    } catch (error) {
      this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
        variant: 'error'
      });
    }
  };

  newSupplierProducerPopup = async (supplierProducerId: number | null) => {
    let newSupplierProducer: SupplierProducer;
    if (supplierProducerId == null) {
      newSupplierProducer = { ...this.state.newSupplierProducer } as SupplierProducer;
    } else {
      newSupplierProducer = this.state.supplierProducerList.find((item) => item.id === supplierProducerId)!;
    }
    this.setState({
      isDialogOpen: true,
      newSupplierProducer: newSupplierProducer,
      newSupplierProducerId: supplierProducerId
    });
  };

  closeDialog = async () => {
    this.setState(
        { 
          isDialogOpen: false, 
          newSupplierProducer: this.newSupplierProducer 
        }
      );
  };

  public render() {
    this.translatorService = (this.context as AppContext).translatorService;
    this.appReferentialService = (this.context as AppContext).referentialService;
    this.workflowService = (this.context as AppContext).workflowService;

    const options = {
      filter: true,
      selectableRows: 'none' as SelectableRows,
      selectableRowsOnClick: false,
      print: false,
      download: false,
      textLabels: MUITranslations.GetTranslations(this.translatorService),
      sort: false,
      // responsive: "stacked",
      customToolbar: () => {
        return (
          <Tooltip title={this.translatorService.Tranlate('Add', 'Adauga')}>
            <IconButton
              aria-label="add"
              color="secondary"
              className="m-2"
              onClick={(e) => this.newSupplierProducerPopup(null)}
            >
              <AddCircleTwoToneIcon />
            </IconButton>
          </Tooltip>
        );
      }
    };
    return (
      <Fragment>
        <AppBar position="static" elevation={0} color="secondary">
          <Tabs
            TabIndicatorProps={{
              style: {
                height: '4px'
              }
            }}
            value={0}
            onChange={undefined}
            variant="fullWidth"
            centered={true}
            indicatorColor="primary"
            aria-label="simple tabs example"
          >
            <Tab
              label={this.translatorService.Tranlate('MENU_SETTINGS_TAB_SUPPLIERS_PRODUCERS', 'Producatori furnizori')}
            />
          </Tabs>
        </AppBar>
        <div className="d-flex flex-row text-center flex-wrap justify-content-center">
          <ScaleLoader color={'var(--primary)'} loading={this.state.isLoading} />
        </div>
        {!this.state.isLoading ? (
          <MUIDataTable
            title={''}
            data={this.state.supplierProducerList}
            columns={this.getColumns()}
            options={options}
          />
        ) : null}

        {this.state.isDialogOpen ? (
          <Dialog
            onClose={this.closeDialog}
            aria-labelledby="customized-dialog-title"
            open={this.state.isDialogOpen}
            fullWidth={true}
            maxWidth={'sm'}
          >
            <DialogTitle id="customized-dialog-title">
              <Grid container>
                <Grid item xs={11}>
                  <Typography variant="h4">
                  {!this.state.newSupplierProducerId ? 
                    this.translatorService.Tranlate(
                        'SUPPLIER_PRODUCER_ADD_MODAL_TITLE',
                        'Adauga Producator Furnizor'
                      ) : this.translatorService.Tranlate(
                        'SUPPLIER_PRODUCER_UPDATE_MODAL_TITLE',
                        'Actualizeaza Producator Furnizor'
                      )}               
                  </Typography>
                </Grid>
                <Grid item xs={1}>
                  <IconButton aria-label="close" onClick={this.closeDialog} size={'small'}>
                    <CloseIcon />
                  </IconButton>
                </Grid>
              </Grid>
            </DialogTitle>
            <DialogContent dividers>{this.renderAddForm()}</DialogContent>
        </Dialog>) : null}
      </Fragment>
    );
  }
}
export default connect(
  (state: ApplicationState) => ({
    appState: state.app
  }),
  null
)(withSnackbar(UserSupplierProducers as any));